import { CMS_CONFIG, IPersonalInfoCMS, useCmsConfig } from '@vfit/consumer/data-access';
import { LoggerInstance } from '@vfit/shared/data-access';
import { API, PAGES } from '@vfit/shared/data-access';
import { Button } from '@vfit/shared/atoms';
import { ConfirmIdentity } from '@vfit/shared/components';
import { IFindCallerObject } from '@vfit/shared/models';
import { organizeConfirmIdentityCard } from './coverageToolChooseContact.utils';
import { useCoverageToolModalProvider } from '../../coverageToolModal.context';
import { organizeCoverageToolCheckNumberCard } from '../CoverageToolCheckNumberCard/coverageToolCheckNumberCard.utils';
import { ICommonData } from '../../../StepperStateCards/stepperStateCards.models';
import { ButtonWrapper } from './coverageToolChooseContact.style';
import CoverageToolChooseContactTagging from './coverageToolChooseContact.tagging';

const CoverageToolChooseContact = ({ handleGoNextSlide }: ICommonData) => {
  const { findCaller, setFindCaller } = useCoverageToolModalProvider();

  const dataFromCms = useCmsConfig(
    CMS_CONFIG[PAGES.CONSUMER],
    API.CMS_GET_PERSONAL_DATA
  ) as IPersonalInfoCMS;

  const handleSelect = (selectedItem: { field: string; fieldType: 'msisdn' | 'email' }) => {
    setFindCaller({
      ...(findCaller as IFindCallerObject),
      selectedContactMedium: selectedItem.field?.trim() ? selectedItem : undefined,
    });
  };

  const { descriptionCms, placeholderCms, titleCms, ctaLabelCms } =
    organizeConfirmIdentityCard(dataFromCms);

  const { checkNumberProps } = organizeCoverageToolCheckNumberCard(dataFromCms);

  const cardConfig = {
    getSelectedData: handleSelect,
    identityTypeItems: [
      (findCaller as IFindCallerObject)?.individualRef?.email || '',
      (findCaller as IFindCallerObject)?.individualRef?.msisdn || '',
    ],
    title: titleCms,
    description: descriptionCms,
    placeholder: placeholderCms,
    cta: {
      label: ctaLabelCms,
      action: () => LoggerInstance.debug('click from'),
    },
  };

  const onSubmit = () => {
    if (handleGoNextSlide && (findCaller as IFindCallerObject)?.selectedContactMedium) {
      handleGoNextSlide();
    }
  };

  return (
    <>
      <CoverageToolChooseContactTagging />
      <ConfirmIdentity data={cardConfig} />
      <ButtonWrapper>
        <Button disabled={false} onClick={onSubmit} variant={'primary'} name="action_checkNumber">
          {checkNumberProps?.ctaLabel || 'Prosegui'}
        </Button>
      </ButtonWrapper>
    </>
  );
};

export default CoverageToolChooseContact;
